/**
 * Filter UI: toggle slide-in container with outside-click + ESC close
 *
 * Markup contract:
 * - Toggle button: .filter-item-toggle-btn [data-control="<key>"]
 * - Container: .filter-item-container [data-target="<key>"]
 *
 * The container in templates already includes Tailwind classes for the hidden state:
 *   opacity-0 translate-x-full transition-all duration-300
 * We toggle to visible state by adding:
 *   opacity-100 translate-x-0
 */

let initialized = false;

function getContainers() {
  return Array.from(document.querySelectorAll(".filter-item-container[data-target]"));
}

function findContainerByKey(key) {
  if (!key) return null;
  return document.querySelector(`.filter-item-container[data-target="${key}"]`);
}

function openContainer(container) {
  if (!container) return;
  container.classList.add("opacity-100", "translate-x-0", "is-open");
  container.classList.remove("opacity-0", "translate-x-full");
}

function closeContainer(container) {
  if (!container) return;
  container.classList.remove("opacity-100", "translate-x-0", "is-open");
  container.classList.add("opacity-0", "translate-x-full");
}

function closeAllContainers(exceptEl = null) {
  getContainers().forEach((el) => {
    if (exceptEl && el === exceptEl) return;
    closeContainer(el);
  });
}

export function initFilterToggles() {
  if (initialized) return;

  // Toggle click (delegated)
  document.addEventListener("click", (e) => {
    const toggleBtn = e.target.closest(".filter-item-toggle-btn");
    if (toggleBtn) {
      const key = toggleBtn.getAttribute("data-control") || toggleBtn.getAttribute("data-target");
      const container =
        findContainerByKey(key) ||
        toggleBtn.closest(".filter-item")?.querySelector(".filter-item-container");
      if (!container) return;

      const isOpen = container.classList.contains("is-open");
      if (isOpen) {
        closeContainer(container);
        toggleBtn.setAttribute("aria-expanded", "false");
      } else {
        openContainer(container);
        toggleBtn.setAttribute("aria-expanded", "true");
      }

      return; // prevent outside-click handler from closing immediately
    }

    // Outside click: close any open container if click is not inside it
    const anyOpen = document.querySelector(".filter-item-container.is-open");
    if (anyOpen && !anyOpen.contains(e.target)) {
      closeAllContainers();
    }
  });

  // ESC key closes all
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      closeAllContainers();
    }
  });

  initialized = true;
}

export default initFilterToggles;
